import { render, staticRenderFns } from "./ServicesArea.vue?vue&type=template&id=4b503dc4&"
import script from "./ServicesArea.vue?vue&type=script&lang=js&"
export * from "./ServicesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports